import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {WebDokuNodeValue} from "../../shared/models/web-doku-node-value";
import {WebdokuService} from "../../web-doku/webdoku.service";
import { Observable, of, Subscription } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { InfoService } from '../../shared/services/info.service';

@Component({
    selector: 'ldw-info-webdoku',
    templateUrl: './info-webdoku.component.html',
    styleUrls: ['./info-webdoku.component.css'],
    standalone: false
})
export class InfoWebdokuComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private webdokuService = inject(WebdokuService);
  private infoService = inject(InfoService);


  public list:WebDokuNodeValue[] = [];
  protected wdSubscription!: Subscription;

  ngOnInit(): void {
    this.wdSubscription =
      this.route.paramMap
        .subscribe((params) => {
          const wd = params.get('wd') ?? '';
          console.log(`start wd info with ${wd}`);
          this.webdokuService.selectWebDoku(wd).pipe(
            switchMap((selectWdOk) => this.getDetail(selectWdOk)),
            take(1)
          ).subscribe();
        }
    )
  }

  getDetail(selectWdOk: boolean): Observable<WebDokuNodeValue[]> {
    if (selectWdOk) {
      console.log(`wd select was successful`);
      return this.webdokuService.getDetails().pipe(
        tap((res) => {
          this.list = res;
          this.infoService.clearStatus();
        })
      );
    }
    else {
      console.log(`wd select was not successful`);
      this.list = [];
      this.infoService.setStatus(`can't activate`);
      return of(this.list);
    }
  }

  ngOnDestroy(): void {
    this.wdSubscription.unsubscribe();
  }
}
